import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type SelectedProductState = {
  cart?: any
  cart_items?: any
  cart_totals?: any
}

const initialState: SelectedProductState = {
  cart: null,
  cart_items: [],
  cart_totals: null,
}

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    resetCart() {
      return initialState
    },

    // set the cart
    setCart(state, action: PayloadAction<any>) {
      state.cart = action.payload.cart
      state.cart_items = action.payload.cart_items
      state.cart_totals = action.payload.cart_totals
    },
  },
})

export const { resetCart, setCart } = cartSlice.actions

export default cartSlice.reducer
